import { useState } from "react"
import { Button, useUIActions, ModalId } from "../../../../../features/ui"
import { InternalNote } from "../../../state/types"
import styles from './notesTabContent.module.css'

type Props = {
    originalNote?: string
    originalDate?: string | Date
    internalNotes: InternalNote[]
}

export const NotesTabContent = ({ originalNote, originalDate, internalNotes }: Props) => {
    const { openModal } = useUIActions()
    const [expandedKeys, setExpandedKeys] = useState<string[]>([])

    const toggle = (key: string) => {
        setExpandedKeys(prev =>
            prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
        )
    }

    const formatDate = (dateInput: Date | string) => {
        const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        return `${day}/${month}/${year} ${hours}:${minutes}`
    }

    const renderNoteItem = (title: string, date: Date | string, text: string, noteKey: string) => {
        const isExpanded = expandedKeys.includes(noteKey)

        return (
            <div className="border-bottom" key={noteKey}>
                <div
                    onClick={() => toggle(noteKey)}
                    className={`p-3 d-flex justify-content-between align-items-center bg-hover-light ${styles.noteHeader}`}
                >
                    <div className="d-flex align-items-center gap-2">
                        <span className="fw-bold text-dark">{title}</span>
                        <span className="text-muted">-</span>
                        <span className="text-muted small">{formatDate(date)}</span>
                    </div>
                    <i className={`bi bi-chevron-${isExpanded ? 'up' : 'down'} text-muted`}></i>
                </div>
                {isExpanded && (
                    <div className={`p-3 bg-light border-top italic ${styles.noteContent}`}>
                        {text}
                    </div>
                )}
            </div>
        )
    }

    return (
        <div>
            <div className="p-3 d-flex justify-content-end border-bottom bg-white sticky-top">
                <Button label="Agregar Nota" icon="plus-lg" kind="primary" small onClick={() => openModal(ModalId.ADD_NOTE)} />
            </div>

            {originalNote && renderNoteItem("Nota del Documento", originalDate || new Date(), originalNote, 'original')}

            {internalNotes.map((note, i) => {
                const noteNumber = internalNotes.length - i
                return renderNoteItem(`Nota Interna #${noteNumber}`, note.date, note.text, note.date)
            })}

            {(!originalNote && internalNotes.length === 0) && (
                <p className="text-muted text-center p-5">No hay notas registradas.</p>
            )}
        </div>
    )
}
